<template>
    <div class="create-rubric">
        <div class="rubric-custom-title">
            <b-form-group
                :label="$t('common.title')"
                label-for="rubric-custom-title-input">
                <b-form-input
                    id="rubric-custom-title-input"
                    v-model="title"
                    type="text"
                    :placeholder="skillName"></b-form-input>
            </b-form-group>
        </div>

        <div class="save-rubric">
            <b-button
                class="btn-save btn-save-rubric"
                variant="primary"
                @click="save">
                {{ $t('common.save') }}
            </b-button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'design-2021-skilltree-rubric-management-levels-modal',
    props: ['count', 'skillIdIn', 'skillSkillTreeIn'],
    data() {
        return {
            title: '',
            skillName: this.skillSkillTreeIn.skill.name + ' ' + this.count.toString(),
        };
    },
    methods: {
        save() {
            let data = {
                title: this.title ? this.title : this.skillName,
                skill_skill_tree_id: this.skillSkillTreeIn.id,
            };

            this.alert.saving();

            this.axios.post(this.routes.skillAddRubric(), data).then(
                (response) => {
                    this.skillSkillTreeIn.addRelation('rubrics', response.data);
                    this.$emit('closeNewRubric');
                    this.alert.success();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
    },
};
</script>

<style scoped lang="scss">
.create-rubric {
    margin-top: map-get($grid-gutter-spacing, 'twenty-one');
}

.edit-skill-tree-table ::v-deep {
    .apprentice-table-header {
        display: none;
    }
}

.save-rubric {
    display: flex;
    justify-content: flex-end;
    width: 100%;
    align-content: center;
}

@media (min-width: map-get($grid-breakpoints, 'sm')) {
    .save-rubric {
        width: auto;
    }
}
</style>
